import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { StepTitle, OField, inputCls, NavButtons, UploadSlot } from "@/components/onboard/ui";
import { toast } from "sonner";

const EMPTY = { name: "", cell: "", truck: "", trailer: "", vin: "", make: "", year: "", cdl_url: "" };
const FIELDS = [["name", "Driver Name *"], ["cell", "Driver Cell *"], ["truck", "Truck # *"], ["trailer", "Trailer #"], ["vin", "VIN # *"], ["make", "Truck Make / Model"], ["year", "Truck Model Year"]];

export function StepDrivers({ token, state, onSaved, onBack }) {
  const n = state.total_trucks;
  const prev = state.wizard.drivers || [];
  const [drivers, setDrivers] = useState(() => Array.from({ length: n }, (_, i) => ({ ...EMPTY, ...(prev[i] || {}) })));
  const [loading, setLoading] = useState(false);
  const set = (i, k, v) => setDrivers(drivers.map((d, j) => (j === i ? { ...d, [k]: v } : d)));

  const save = async () => {
    setLoading(true);
    try { const { data } = await api.post(`/onboard/${token}/save`, { step: "drivers", data: drivers }); onSaved(data); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <StepTitle kicker="Step 6 · Drivers & Equipment" title={`Driver Details for ${n} Truck${n > 1 ? "s" : ""}`} sub="One driver per truck. We use this to set up broker packets and dispatch your loads." />
      <div className="space-y-5">
        {drivers.map((d, i) => (
          <div key={i} className="rounded-3xl border border-white/10 bg-white/[0.02] p-5 sm:p-6" data-testid={`ob-driver-${i}`}>
            <p className="font-heading font-bold text-white mb-4">Driver {i + 1}</p>
            <div className="grid sm:grid-cols-3 gap-4">
              {FIELDS.map(([k, l]) => (
                <OField key={k} label={l}><input value={d[k]} onChange={(e) => set(i, k, e.target.value)} className={`${inputCls} ${["vin", "year", "truck", "trailer"].includes(k) ? "font-mono" : ""}`} data-testid={`ob-driver-${i}-${k}`} /></OField>
              ))}
              <div className="sm:col-span-2">
                <span className="block text-[11px] font-semibold uppercase tracking-[0.14em] text-white/50 mb-1.5">Driver CDL / DL *</span>
                <UploadSlot token={token} label="Upload CDL / DL" value={d.cdl_url ? { url: d.cdl_url, name: "CDL uploaded" } : null} onChange={(v) => set(i, "cdl_url", v.url)} testid={`ob-driver-${i}-cdl`} />
              </div>
            </div>
          </div>
        ))}
      </div>
      <NavButtons onBack={onBack} onNext={save} loading={loading} nextLabel="Save Drivers" />
    </div>
  );
}
